import React, { useContext, useEffect, useState } from 'react'
import { Form, ButtonGroup, Button } from 'reactstrap';
import { DonutChart } from '../Charts/DonutChart/DonutChart';
import './widgets.css';
import { t } from 'i18next';
import { getDataUserByKey, getUserBuilding, getUserOpening } from '../../helpers/helpers';
import { CustomAlert } from '../CustomAlert/CustomAlert';
import { useNavigate } from 'react-router-dom';
import EntryAndDepartureReportContext from '../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext';
import AccessHoursContext from '../../context/AccessHoursContext/AccessHoursContext';
import { resTypesInitial } from './dashboardHelpers';
import WidgetResourcesInHourContext from '../../context/WidgetResourcesInHour/WidgetResourcesInHourContext';

const NumberOfResourcesByHours = () => {
    const navigate = useNavigate();

    const { entryAndDepartureReportState, setFilters } = useContext(EntryAndDepartureReportContext);
    const { filters } = entryAndDepartureReportState;

    const { accessHoursState, getAccessHours } = useContext(AccessHoursContext);
    const { accessHours } = accessHoursState;

    const { widgetResourcesInHourState, getResourcesInPlaceByHours } = useContext(WidgetResourcesInHourContext);
    const { error, resources, isFetching } = widgetResourcesInHourState;

    const isGuard = Number(getDataUserByKey('access_profile_id')) === 3;

    const openingSelected = getUserOpening();
    const buildingSelected = getUserBuilding();

    const openingSelectedInLocalStorage = openingSelected.codigo !== "";
    const buildingSelectedInLocalStorage = buildingSelected.buildingId !== "";

    const keyType = Object.keys(resTypesInitial);

    const [data, setData] = useState(resources);
    const [resTypes, setResTypes] = useState(resTypesInitial);
    const typesExample = [t('EMPS'), t('VEHS'), t('VISITS')];

    const filtersInitial = {
        date_from: '',
        date_to: '',
        resource_type: [],
        contractors: [],
        search_text: '',
        opening_code: [],
        user_created: [],
        permanence_time_from: 0,
        permanence_time_to: null,
        column_order: 'name',
        order_type: 'DESC',
        buildings: [],
        areas: [],
        in_plant: false,
        reg_from: 1,
        page_length: filters.page_length
    }

    const getResourcesByHour = async () => {
        await getAccessHours();

        const guardOpeningSelected = isGuard && openingSelectedInLocalStorage ? openingSelected.codigo : '';
        const guardBuildingSelected = isGuard && buildingSelectedInLocalStorage ? buildingSelected.buildingId : '';

        await getResourcesInPlaceByHours(guardOpeningSelected, guardBuildingSelected);
    }

    const handleChangeResType = (valueKey, value) => {
        setResTypes({
            ...resTypes,
            [valueKey]: value
        })
    }

    const getDataByResourcesType = () => {
        let dataToChart = [];
        resources.forEach((el) => {
            let total = 0;
            total = resTypes.employeesIn && el.employeesIn ? total + el.employeesIn : total;
            total = resTypes.vehiclesIn && el.vehiclesIn ? total + el.vehiclesIn : total;
            total = resTypes.visitorsIn && el.visitorsIn ? total + el.visitorsIn : total;
            dataToChart.push({ type: `${el.hours} ${t('HOURS')} `, value: total, identifier: el.hours });
        });

        setData(dataToChart);
    }

    const getResTypesSelectedToRedirect = () => {
        const resTypesSelected = [];
        const typesToFilter = {
            employeesIn: 'EMP',
            vehiclesIn: 'VEH',
            visitorsIn: 'VIS'
        };
        for (const property in resTypes) {
            if (resTypes[property]) {
                resTypesSelected.push(typesToFilter[property])
            }
        }
        return resTypesSelected
    }

    const getPreviousHour = (value) => {

        const index = accessHours.findIndex(op => op.hour === value.toString());

        if (index > 0) {
            return Number(accessHours[index - 1].hour);
        } else {
            return null; // No hay objeto anterior al valor proporcionado
        }
    }

    const redirectToReport = (timeRange) => {
        const haveOpening = getUserOpening();
        const openingCode = haveOpening.codigo !== "" ? [haveOpening.codigo] : []
        const ResType = getResTypesSelectedToRedirect();

        setFilters({
            ...filtersInitial,
            opening_code: openingCode,
            resource_type: ResType,
            in_plant: true,
            permanence_time_from: getPreviousHour(timeRange.identifier),
            permanence_time_to: timeRange.identifier === '+24' ? null : Number(timeRange.identifier),
        });

        navigate('/reports/entryAndDeparture')
    }

    useEffect(() => {
        getResourcesByHour();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        getDataByResourcesType();
        // eslint-disable-next-line
    }, [widgetResourcesInHourState, resTypes])

    return (
        <>
            <div>
                <p className='widgetTitle'>{t('RES_BY_HOURS')}</p>
            </div>

            {error.ok ?
                <CustomAlert color={'danger'} text={error.text} />
                :
                <>
                    <div className='mb-2'>
                        <Form className='resTypeWidget'>
                            <ButtonGroup>
                                {typesExample.map((type, i) => {
                                    return (
                                        <Button
                                            key={i}
                                            color=""
                                            className={`${i === 0 ? 'btn-radius-start' : i === typesExample.length - 1 ? 'btn-radius-end' : ''} btn-outline-black`}
                                            outline
                                            onClick={() => handleChangeResType(keyType[i], !resTypes[keyType[i]])}
                                            active={resTypes[keyType[i]]}
                                        >
                                            <div className='d-flex flex-column align-items-center'>
                                                <div className='d-flex align-items-center '>
                                                    {type}
                                                    <i className={`ms-1 fa-solid ${resTypes[keyType[i]] ? 'fa-check' : 'fa-xmark'}`}></i>
                                                </div>
                                            </div>
                                        </Button>
                                    )
                                })}
                            </ButtonGroup>
                        </Form>
                    </div>

                    <div className=''>
                        <DonutChart
                            idChart={'legendByHour'}
                            dataChart={data}
                            widthChart={150}
                            heightChart={150}
                            withLegendProgressBar={true}
                            loadding={isFetching}
                            redirect={redirectToReport}
                        />
                    </div>
                </>
            }
        </>
    )
}
export default NumberOfResourcesByHours